import styled from "styled-components";
import { ModalHeader, RotaButton } from "@teamrota/rota-design";

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  padding: 32px 0;
`;

export const ReserveButton = styled(RotaButton)`
  background-color: #6c757d;
  border-color: #6c757d;

  &:hover {
    background-color: #5a6268;
    border-color: #5a6268;
  }
`;

export const AssignButton = styled(RotaButton)`
  background-color: #ff9500;
  border-color: #ff9500;

  &:hover {
    background-color: #e6850e;
    border-color: #e6850e;
  }
`;

export const CancelButton = styled(RotaButton)`
  background-color: transparent;
  border-color: #d32f2f;
  color: #d32f2f;

  &:hover {
    background-color: #d32f2f;
    border-color: #d32f2f;
    color: white;
  }
`;

export const Text = styled.div`
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.4;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  margin: 32px 0 64px;
  gap: 8px;
  padding-left: 12px;
`;

export const RadioLabel = styled.label`
  display: flex;
  text-align: left;
  padding-bottom: 10px;
  cursor: pointer;

  input[type="radio"] {
    margin-top: 2px;
    margin-right: 10px;
    cursor: pointer;
  }

  span {
    font-size: 14px;
  }
`;

export const StyledModalHeader = styled(ModalHeader)`
  h3 {
    font-size: 16px !important;
  }
`;
